module.exports = __webpack_public_path__ + "./fonts/IBMPlexSans_200ExtraLight.ttf";